/* ═══════════════════════════════════════════════
   MCC Live Status Ticker
   Updates: local time, countdown, lights status, temp
   ═══════════════════════════════════════════════ */

(function() {
  function mccTick() {
    var now = new Date();

    // CST display
    var localTimeEl = document.getElementById('mcc-local-time');
    if (localTimeEl) {
      var t = now.toLocaleTimeString('en-US', {
        timeZone: 'America/Chicago',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
      localTimeEl.textContent = t + ' CST';
    }

    // Countdown to 11:59 PM CT
    var countdownEl = document.getElementById('mcc-countdown');
    if (countdownEl) {
      var ct = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      var tgt = new Date(ct);
      tgt.setHours(23, 59, 0, 0);
      if (ct >= tgt) tgt.setDate(tgt.getDate() + 1);
      var d = Math.max(0, tgt - ct);
      var h = Math.floor(d / 3600000);
      var m = Math.floor((d % 3600000) / 60000);
      var s = Math.floor((d % 60000) / 1000);
      countdownEl.textContent =
        String(h).padStart(2, '0') + ':' +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0');
    }

    // Lights status
    var lightsEl = document.getElementById('mcc-lights-status');
    if (lightsEl) {
      var ct2 = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      var ch = ct2.getHours();
      var cm = ct2.getMinutes();
      if ((ch === 23 && cm >= 58) || (ch === 0 && cm === 0)) {
        lightsEl.textContent = 'ACTIVE \u2B24';
        lightsEl.style.color = '#88d2f8';
      } else {
        lightsEl.textContent = 'Inactive';
        lightsEl.style.color = 'rgba(136,210,248,0.5)';
      }
    }

    // Temp flicker
    var tempEl = document.getElementById('mcc-range-temp');
    if (tempEl) {
      tempEl.textContent = Math.round(94 + Math.sin(Date.now() / 28000) * 2) + '\u00B0F';
    }
  }

  // Run on load and every second
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      mccTick();
      setInterval(mccTick, 1000);
    });
  } else {
    mccTick();
    setInterval(mccTick, 1000);
  }
})();
